import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

interface ApiKeyDialogProps {
  open: boolean;
  onSave: (apiKey: string) => void;
}

const ApiKeyDialog: React.FC<ApiKeyDialogProps> = ({ open, onSave }) => {
  const [inputKey, setInputKey] = useState("");

  const handleSave = () => {
    if (inputKey.trim()) {
      localStorage.setItem("apiKey", inputKey.trim());
      onSave(inputKey.trim());
    }
  };

  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogTitle>Clé API requise</DialogTitle>
      <DialogContent>
        <TextField
          label="Votre clé API"
          fullWidth
          value={inputKey}
          onChange={(e) => setInputKey(e.target.value)}
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSave} variant="contained">
          Valider
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApiKeyDialog;
